const clean = (params = {}) => Object.fromEntries(Object.entries(params).filter(([, value]) => value !== "" && value != null));

const createSynceeApi = ({ baseUrl, getToken }) => {
  const request = async (path, { method = "GET", body, params } = {}) => {
    const query = new URLSearchParams(clean(params)).toString();
    const token = typeof getToken === "function" ? getToken() : getToken;
    const response = await fetch(`${String(baseUrl || "").replace(/\/$/, "")}${path}${query ? `?${query}` : ""}`, {
      method,
      headers: { Accept: "application/json", "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw Object.assign(new Error(data.error || `HTTP ${response.status}`), { status: response.status, code: data.code });
    return data;
  };
  return {
    getPlatform: () => request("/dropshipping/syncee/platform"),
    getConnection: () => request("/dropshipping/syncee/connection"),
    getSignup: () => request("/dropshipping/syncee/signup"),
    connect: (payload = {}) => request("/dropshipping/syncee/connect", { method: "POST", body: payload }),
    testConnection: () => request("/dropshipping/syncee/test-connection", { method: "POST" }),
    disconnect: () => request("/dropshipping/syncee/disconnect", { method: "POST" }),
    getSuppliers: () => request("/dropshipping/syncee/suppliers"),
    getSupplierProducts: (supplierId, params) => request(`/dropshipping/syncee/suppliers/${supplierId}/products`, { params }),
    getProducts: (params) => request("/dropshipping/syncee/products", { params }),
    getProduct: (id) => request(`/dropshipping/syncee/products/${id}`),
    importProduct: (payload) => request("/dropshipping/syncee/products/import", { method: "POST", body: payload }),
    syncAll: () => request("/dropshipping/syncee/sync", { method: "POST" }),
    syncProduct: (id) => request(`/dropshipping/syncee/products/${id}/sync`, { method: "POST" }),
    getImportedProducts: (params) => request("/dropshipping/syncee/imported-products", { params }),
    getOrders: (params) => request("/dropshipping/syncee/orders", { params }),
    createSupplierOrder: (orderId, sellerId) => request(`/dropshipping/syncee/orders/${orderId}/create`, { method: "POST", body: sellerId ? { sellerId } : {} }),
    syncOrder: (id) => request(`/dropshipping/syncee/orders/${id}/sync`, { method: "POST" }),
    getErrors: () => request("/dropshipping/syncee/errors"),
    getAdminOverview: () => request("/dropshipping/syncee/admin/overview"),
    getAdminConnections: () => request("/dropshipping/syncee/admin/connections"),
    updateAdminPlatform: (payload) => request("/dropshipping/syncee/admin/platform", { method: "PATCH", body: payload }),
    syncAllSellers: () => request("/dropshipping/syncee/admin/sync", { method: "POST" }),
  };
};

module.exports = { createSynceeApi };
